export function setRequests(state, payload) {
  state.requests = payload;
}
